import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please connect to Supabase using the "Connect to Supabase" button.'
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: localStorage,
    storageKey: `sb-${supabaseUrl}-auth-token`
  }
});

// Add auth state change listener
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
    // Clear any cached data
    localStorage.removeItem(`sb-${supabaseUrl}-auth-token`);
    
    // Clear app storage
    localStorage.removeItem('app-storage');
    
    // Reload the page to clear any in-memory state
    window.location.reload();
  }

  // Handle email confirmation
  if (event === 'USER_UPDATED' && session?.user.email_confirmed_at) {
    // Redirect to home after email confirmation
    window.location.href = '/';
  }

  // Handle successful sign in
  if (event === 'SIGNED_IN') {
    // Remove any auth fragments from URL
    if (window.location.hash.includes('access_token')) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
});